import { AccountType } from '@logz-pkg/enums';
const readableAccountType = {
    [AccountType.Owner]: 'Owner Account',
    [AccountType.Sub]: 'Sub Account',
    [AccountType.Security]: 'Security Account',
    [AccountType.Timeless]: 'Timeless Account',
    [AccountType.Metrics]: 'Metrics Account',
    [AccountType.Restore]: 'Restore Account',
    [AccountType.Tracing]: 'Tracing Account',
};
class AccountModelManipulator {
    getReadableType = (key) => readableAccountType[key];
    isOwner = ({ type }) => type === AccountType.Owner;
    isSub = ({ type }) => type === AccountType.Sub;
    isSecurity = ({ type }) => type === AccountType.Security;
    isTimeless = ({ type }) => type === AccountType.Timeless;
    isMetrics = ({ type }) => type === AccountType.Metrics;
    isRestore = ({ type }) => type === AccountType.Restore;
    isTracing = ({ type }) => type === AccountType.Tracing;
    /**
     * @deprecated
     */
    deprecatedIsOwner = (accountType) => accountType === AccountType.Owner;
    /**
     * @deprecated
     */
    deprecatedIsTimeless = (accountType) => accountType === AccountType.Timeless;
    /**
     * @deprecated
     */
    deprecatedIsMetrics = (accountType) => accountType === AccountType.Metrics;
}
export const accountModelManipulator = new AccountModelManipulator();
//# sourceMappingURL=model.manipulator.js.map